import { _ as _slicedToArray, b as useCreateAsset, u as useAsset, d as usePlaybackInfo, a as prefetchPlaybackInfo } from './usePlaybackInfo-e8ccb0c2.esm.js';
import 'core-js/modules/es.array.map.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/web.url.js';
import 'core-js/modules/web.url-search-params.js';
import 'core-js/modules/es.regexp.to-string.js';
import 'core-js/modules/es.string.starts-with.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.number.constructor.js';
import { canPlayMediaNatively, parseCid, parseArweaveTxId, getMediaSourceType, addMediaMetrics } from 'livepeer/media';
import { deepMerge, isNumber } from 'livepeer/utils';
import * as React from 'react';
import { _ as _objectWithoutProperties } from './client-19c3a323.esm.js';
import { createPlayerTheme, styling } from 'livepeer/styling';
import { u as useClient, a as ThemeContext } from './context-dc86cecf.esm.js';
import { createControllerStore, addEventListeners, isPictureInPictureSupported } from 'livepeer/media/controls';
import create from 'zustand';
import { _ as _asyncToGenerator, a as _regeneratorRuntime, b as _objectSpread2 } from './useInternalQuery-8432b378.esm.js';
import { isHlsSupported, createNewHls } from 'livepeer/media/hls';

var MediaControllerContext = /*#__PURE__*/React.createContext(create(createControllerStore(null)));

var MediaControllerProvider = function MediaControllerProvider(_ref) {
  var element = _ref.element,
    children = _ref.children,
    options = _ref.options;
  var useMediaController = useMediaControllerStore(element, options);
  return /*#__PURE__*/React.createElement(MediaControllerContext.Provider, {
    value: useMediaController
  }, children);
};
var useMediaControllerStore = function useMediaControllerStore(element, options) {
  var client = useClient();
  var useStore = React.useMemo(function () {
    return create(createControllerStore(element, client.storage));
  }, [element, client === null || client === void 0 ? void 0 : client.storage]);
  React.useEffect(function () {
    var _addEventListeners = addEventListeners(useStore, options),
      destroy = _addEventListeners.destroy;
    return function () {
      destroy === null || destroy === void 0 ? void 0 : destroy();
    };
  }, [useStore, options]);
  return useStore;
};

var useMediaController = function useMediaController(selector) {
  // typecast the context so that we can have video/audio-specific controller states
  var useMediaControllerInternal = React.useContext(MediaControllerContext);
  return useMediaControllerInternal(selector);
};

var useTheme = function useTheme(theme) {
  var contextTheme = React.useContext(ThemeContext);
  var containerTheme = React.useMemo(function () {
    var mergedTheme = contextTheme ? theme ? deepMerge(contextTheme, theme) : contextTheme : theme;
    return mergedTheme ? createPlayerTheme(mergedTheme) : undefined;
  }, [theme, contextTheme]);
  return containerTheme;
};

/**
 * As prop
 */

var useConditionalIcon = function useConditionalIcon(conditional, truthyIcon, truthyDefaultIcon, falsyIcon, falsyDefaultIcon) {
  var element = React.useMemo(function () {
    return conditional ? truthyIcon !== null && truthyIcon !== void 0 ? truthyIcon : truthyDefaultIcon : falsyIcon !== null && falsyIcon !== void 0 ? falsyIcon : falsyDefaultIcon;
  }, [conditional, truthyIcon, truthyDefaultIcon, falsyIcon, falsyDefaultIcon]);
  return React.useMemo(function () {
    return /*#__PURE__*/React.isValidElement(element) ? /*#__PURE__*/React.cloneElement(element) : null;
  }, [element]);
};
var useMemoizedIcon = function useMemoizedIcon(icon, defaultIcon) {
  return React.useMemo(function () {
    return icon && /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon) : defaultIcon;
  }, [icon, defaultIcon]);
};

var mediaControllerSelector$c = function mediaControllerSelector(_ref) {
  var device = _ref.device;
  return {
    device: device
  };
};
var BaseSlider = function BaseSlider(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$c),
    device = _useMediaController.device;
  var ref = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isActive = _React$useState2[0],
    setIsActive = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isDragging = _React$useState4[0],
    setIsDragging = _React$useState4[1];
  var isActiveOrDragging = React.useMemo(function () {
    return (device === null || device === void 0 ? void 0 : device.isMobile) || isActive || isDragging;
  }, [device === null || device === void 0 ? void 0 : device.isMobile, isActive, isDragging]);
  var onUpdate = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(eventX) {
      var _ref$current;
      var bounding, _props$onChange, newValue, newBoundedValue;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              bounding = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
              if (!bounding) {
                _context.next = 6;
                break;
              }
              newValue = (eventX - bounding.left) / bounding.width;
              newBoundedValue = Math.min(Math.max(0, newValue), 1);
              _context.next = 6;
              return props === null || props === void 0 ? void 0 : (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, newBoundedValue);
            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [props]);
  React.useEffect(function () {
    if (isDragging) {
      var _document, _document2, _document3, _document4;
      var onMouseMove = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e) {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return onUpdate(e.clientX);
                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
        return function onMouseMove(_x2) {
          return _ref3.apply(this, arguments);
        };
      }();
      var onTouchMove = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
          var _e$touches, _e$touches$item, _e$touches$item$call;
          var clientX;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  clientX = (_e$touches = e.touches) === null || _e$touches === void 0 ? void 0 : (_e$touches$item = _e$touches.item) === null || _e$touches$item === void 0 ? void 0 : (_e$touches$item$call = _e$touches$item.call(_e$touches, 0)) === null || _e$touches$item$call === void 0 ? void 0 : _e$touches$item$call.clientX;
                  if (!clientX) {
                    _context3.next = 4;
                    break;
                  }
                  _context3.next = 4;
                  return onUpdate(clientX);
                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return function onTouchMove(_x3) {
          return _ref4.apply(this, arguments);
        };
      }();
      var onMouseUp = /*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
          var _props$onDone;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  setIsDragging(false);
                  _context4.next = 3;
                  return onUpdate(e.clientX);
                case 3:
                  _context4.next = 5;
                  return props === null || props === void 0 ? void 0 : (_props$onDone = props.onDone) === null || _props$onDone === void 0 ? void 0 : _props$onDone.call(props);
                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));
        return function onMouseUp(_x4) {
          return _ref5.apply(this, arguments);
        };
      }();
      var onTouchEnd = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
          var _e$touches2, _e$touches2$item, _e$touches2$item$call, _props$onDone2;
          var clientX;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  setIsDragging(false);
                  clientX = (_e$touches2 = e.touches) === null || _e$touches2 === void 0 ? void 0 : (_e$touches2$item = _e$touches2.item) === null || _e$touches2$item === void 0 ? void 0 : (_e$touches2$item$call = _e$touches2$item.call(_e$touches2, 0)) === null || _e$touches2$item$call === void 0 ? void 0 : _e$touches2$item$call.clientX;
                  if (!clientX) {
                    _context5.next = 5;
                    break;
                  }
                  _context5.next = 5;
                  return onUpdate(clientX);
                case 5:
                  _context5.next = 7;
                  return props === null || props === void 0 ? void 0 : (_props$onDone2 = props.onDone) === null || _props$onDone2 === void 0 ? void 0 : _props$onDone2.call(props);
                case 7:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));
        return function onTouchEnd(_x5) {
          return _ref6.apply(this, arguments);
        };
      }();
      (_document = document) === null || _document === void 0 ? void 0 : _document.addEventListener('mousemove', onMouseMove);
      (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.addEventListener('mouseup', onMouseUp);
      (_document3 = document) === null || _document3 === void 0 ? void 0 : _document3.addEventListener('touchmove', onTouchMove);
      (_document4 = document) === null || _document4 === void 0 ? void 0 : _document4.addEventListener('touchend', onTouchEnd);
      // TODO handle mouse out

      return function () {
        var _document5, _document6, _document7, _document8;
        (_document5 = document) === null || _document5 === void 0 ? void 0 : _document5.removeEventListener('mousemove', onMouseMove);
        (_document6 = document) === null || _document6 === void 0 ? void 0 : _document6.removeEventListener('mouseup', onMouseUp);
        (_document7 = document) === null || _document7 === void 0 ? void 0 : _document7.removeEventListener('touchmove', onTouchMove);
        (_document8 = document) === null || _document8 === void 0 ? void 0 : _document8.removeEventListener('touchend', onTouchEnd);
      };
    }
  }, [isDragging, onUpdate, props]);
  var _handle = useMemoizedIcon(props === null || props === void 0 ? void 0 : props.thumbIcon, /*#__PURE__*/React.createElement("div", {
    className: styling.slider.thumb()
  }));
  var _React$useMemo = React.useMemo(function () {
      return [!isNaN(props.value) ? props.value : 0, props.secondaryValue && !isNaN(props.value) && !isNaN(props.secondaryValue) ? props.secondaryValue - props.value : 0];
    }, [props.value, props.secondaryValue]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    value = _React$useMemo2[0],
    middleValue = _React$useMemo2[1];
  var rightValue = React.useMemo(function () {
    return 1 - (value + middleValue);
  }, [value, middleValue]);
  var onPointerDown = React.useCallback( /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(e) {
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return onUpdate(e.clientX);
            case 2:
              setIsDragging(true);
            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));
    return function (_x6) {
      return _ref7.apply(this, arguments);
    };
  }(), [onUpdate]);
  var onMouseEnter = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            setIsActive(true);
          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  })), [setIsActive]);
  var onMouseLeave = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            setIsActive(false);
          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  })), [setIsActive]);
  var valueRounded = React.useMemo(function () {
    return Math.round(value * 100);
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    onPointerDown: onPointerDown,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    role: "slider",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": valueRounded,
    "aria-valuetext": "".concat(valueRounded, "% ").concat(props.ariaName),
    "aria-orientation": "horizontal",
    className: styling.slider.container()
  }, value > 0.001 && /*#__PURE__*/React.createElement("div", {
    className: styling.slider.track.left({
      size: isActiveOrDragging ? 'active' : 'default',
      rounded: value === 1 && !isActiveOrDragging ? 'full' : 'left',
      css: {
        flex: value
      }
    })
  }), isActiveOrDragging && _handle, (middleValue !== null && middleValue !== void 0 ? middleValue : 0) > 0 && /*#__PURE__*/React.createElement("div", {
    className: styling.slider.track.middle({
      size: isActiveOrDragging ? 'active' : 'default',
      rounded: middleValue === 1 ? !isActiveOrDragging ? 'full' : 'right' : value <= 0.001 ? 'left' : rightValue === 0 ? 'right' : 'none',
      css: {
        flex: middleValue
      }
    })
  }), (rightValue !== null && rightValue !== void 0 ? rightValue : 0) > 0 && /*#__PURE__*/React.createElement("div", {
    className: styling.slider.track.right({
      size: isActiveOrDragging ? 'active' : 'default',
      rounded: value <= 0.001 && !isActiveOrDragging ? 'full' : 'right',
      css: {
        flex: rightValue
      }
    })
  }));
};

var mediaControllerSelector$b = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var Container = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
    className = props.className,
    aspectRatio = props.aspectRatio;
  var _useMediaController = useMediaController(mediaControllerSelector$b),
    fullscreen = _useMediaController.fullscreen;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'contents'
    },
    className: className
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.container({
      aspectRatio: aspectRatio,
      size: fullscreen ? 'fullscreen' : 'default'
    }),
    ref: ref,
    tabIndex: 0
  }, children));
});
Container.displayName = 'Container';

var mediaControllerSelector$a = function mediaControllerSelector(_ref) {
  var hidden = _ref.hidden,
    togglePlay = _ref.togglePlay,
    canPlay = _ref.canPlay,
    hasPlayed = _ref.hasPlayed,
    buffered = _ref.buffered;
  return {
    hidden: hidden,
    togglePlay: togglePlay,
    canPlay: canPlay,
    hasPlayed: hasPlayed,
    buffered: buffered
  };
};
var ControlsContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var top = props.top,
    middle = props.middle,
    left = props.left,
    right = props.right,
    poster = props.poster,
    _props$showLoadingSpi = props.showLoadingSpinner,
    showLoadingSpinner = _props$showLoadingSpi === void 0 ? true : _props$showLoadingSpi,
    _props$hidePosterOnPl = props.hidePosterOnPlayed,
    hidePosterOnPlayed = _props$hidePosterOnPl === void 0 ? true : _props$hidePosterOnPl,
    topLoadingText = props.topLoadingText;
  var _useMediaController = useMediaController(mediaControllerSelector$a),
    hidden = _useMediaController.hidden,
    togglePlay = _useMediaController.togglePlay,
    canPlay = _useMediaController.canPlay,
    hasPlayed = _useMediaController.hasPlayed,
    buffered = _useMediaController.buffered;
  var isLoaded = React.useMemo(function () {
    return canPlay || buffered !== 0;
  }, [canPlay, buffered]);
  var onClickBackground = React.useCallback(function () {
    if (isLoaded) {
      togglePlay();
    }
  }, [togglePlay, isLoaded]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, poster ? /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.background({
      display: hasPlayed && hidePosterOnPlayed ? 'hidden' : 'shown'
    }),
    onMouseUp: onClickBackground
  }, poster) : /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.background({
      display: 'hidden'
    }),
    onMouseUp: onClickBackground
  }), showLoadingSpinner && !isLoaded && /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.background(),
    onMouseUp: onClickBackground
  }, topLoadingText && /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.loadingText()
  }, topLoadingText), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.loading()
  })), isLoaded && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.gradient({
      display: hidden ? 'hidden' : 'shown'
    }),
    onMouseUp: onClickBackground
  }), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.top.container({
      display: hidden ? 'hidden' : 'shown'
    })
  }, top), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.container({
      display: hidden ? 'hidden' : 'shown'
    }),
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.middle.container()
  }, middle), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.lower.container()
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.lower.left()
  }, left), /*#__PURE__*/React.createElement("div", {
    className: styling.controlsContainer.bottom.lower.right()
  }, right)))));
});
ControlsContainer.displayName = 'ControlsContainer';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var _excluded$4 = ["enterIcon", "exitIcon", "onClick"];
var DefaultEnterFullscreenIcon = function DefaultEnterFullscreenIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 10,16 2,0 0,-4 4,0 0,-2 L 10,10 l 0,6 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 20,10 0,2 4,0 0,4 2,0 L 26,10 l -6,0 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 24,24 -4,0 0,2 L 26,26 l 0,-6 -2,0 0,4 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M 12,20 10,20 10,26 l 6,0 0,-2 -4,0 0,-4 0,0 z"
  }));
};
var DefaultExitFullscreenIcon = function DefaultExitFullscreenIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 14,14 -4,0 0,2 6,0 0,-6 -2,0 0,4 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 22,14 0,-4 -2,0 0,6 6,0 0,-2 -4,0 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 20,26 2,0 0,-4 4,0 0,-2 -6,0 0,6 0,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m 10,22 4,0 0,4 2,0 0,-6 -6,0 0,2 0,0 z"
  }));
};
var mediaControllerSelector$9 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen,
    pictureInPicture = _ref.pictureInPicture,
    requestToggleFullscreen = _ref.requestToggleFullscreen;
  return {
    fullscreen: fullscreen,
    pictureInPicture: pictureInPicture,
    requestToggleFullscreen: requestToggleFullscreen
  };
};
var FullscreenButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$9),
    fullscreen = _useMediaController.fullscreen,
    pictureInPicture = _useMediaController.pictureInPicture,
    requestToggleFullscreen = _useMediaController.requestToggleFullscreen;
  var enterIcon = props.enterIcon,
    exitIcon = props.exitIcon,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded$4);
  var onClickComposed = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);
            case 2:
              _context.next = 4;
              return requestToggleFullscreen();
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onClick, requestToggleFullscreen]);
  var _children = useConditionalIcon(fullscreen, exitIcon, /*#__PURE__*/React.createElement(DefaultExitFullscreenIcon, null), enterIcon, /*#__PURE__*/React.createElement(DefaultEnterFullscreenIcon, null));
  var title = React.useMemo(function () {
    return fullscreen ? 'Exit full screen (f)' : 'Full screen (f)';
  }, [fullscreen]);
  if (pictureInPicture) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    ref: ref,
    onClick: onClickComposed
  }), _children);
});
FullscreenButton.displayName = 'FullscreenButton';

var _excluded$3 = ["icon", "onClick"];
var DefaultPictureInPictureIcon = function DefaultPictureInPictureIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M25,17 L17,17 L17,23 L25,23 L25,17 L25,17 Z M29,25 L29,10.98 C29,9.88 28.1,9 27,9 L9,9 C7.9,9 7,9.88 7,10.98 L7,25 C7,26.1 7.9,27 9,27 L27,27 C28.1,27 29,26.1 29,25 L29,25 Z M27,25.02 L9,25.02 L9,10.97 L27,10.97 L27,25.02 L27,25.02 Z"
  }));
};
var mediaControllerSelector$8 = function mediaControllerSelector(_ref) {
  var requestTogglePictureInPicture = _ref.requestTogglePictureInPicture,
    pictureInPicture = _ref.pictureInPicture,
    _element = _ref._element,
    fullscreen = _ref.fullscreen;
  return {
    requestTogglePictureInPicture: requestTogglePictureInPicture,
    pictureInPicture: pictureInPicture,
    _element: _element,
    fullscreen: fullscreen
  };
};
var PictureInPictureButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$8),
    requestTogglePictureInPicture = _useMediaController.requestTogglePictureInPicture,
    _element = _useMediaController._element,
    pictureInPicture = _useMediaController.pictureInPicture,
    fullscreen = _useMediaController.fullscreen;
  var icon = props.icon,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded$3);
  var onClickComposed = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);
            case 2:
              _context.next = 4;
              return requestTogglePictureInPicture();
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onClick, requestTogglePictureInPicture]);
  var isPiPSupported = React.useMemo(function () {
    return isPictureInPictureSupported(_element);
  }, [_element]);
  var title = React.useMemo(function () {
    return pictureInPicture ? 'Exit mini player (i)' : 'Mini player (i)';
  }, [pictureInPicture]);

  // do not show button if it is not supported or if currently fullscreen
  if (!isPiPSupported || fullscreen) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
  var _children = icon ? icon : /*#__PURE__*/React.createElement(DefaultPictureInPictureIcon, null);
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    ref: ref,
    onClick: onClickComposed
  }), _children);
});
PictureInPictureButton.displayName = 'PictureInPictureButton';

var _excluded$2 = ["playIcon", "pauseIcon", "onClick"];
var DefaultPlayIcon = function DefaultPlayIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12,26 18.5,22 18.5,14 12,10 z M 18.5,22 25,18 25,18 18.5,14 z",
    fill: "currentColor"
  }));
};
var DefaultPauseIcon = function DefaultPauseIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    // fillRule="evenodd"
    // clipRule="evenodd"
    d: "M 12,26 16,26 16,10 12,10 z M 21,26 25,26 25,10 21,10 z",
    fill: "currentColor"
  }));
};
var mediaControllerSelector$7 = function mediaControllerSelector(_ref) {
  var togglePlay = _ref.togglePlay,
    playing = _ref.playing;
  return {
    togglePlay: togglePlay,
    playing: playing
  };
};
var PlayButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$7),
    togglePlay = _useMediaController.togglePlay,
    playing = _useMediaController.playing;
  var playIcon = props.playIcon,
    pauseIcon = props.pauseIcon,
    onClick = props.onClick,
    rest = _objectWithoutProperties(props, _excluded$2);
  var onClickComposed = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);
            case 2:
              _context.next = 4;
              return togglePlay();
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function onClickComposed(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var _children = useConditionalIcon(playing, pauseIcon, /*#__PURE__*/React.createElement(DefaultPauseIcon, null), playIcon, /*#__PURE__*/React.createElement(DefaultPlayIcon, null));
  var title = React.useMemo(function () {
    return playing ? 'Pause (k)' : 'Play (k)';
  }, [playing]);
  return /*#__PURE__*/React.createElement("button", _extends({}, rest, {
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    ref: ref,
    onClick: onClickComposed
  }), _children);
});

var mediaControllerSelector$6 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var Poster = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$6),
    fullscreen = _useMediaController.fullscreen;
  var content = props.content,
    title = props.title;
  return typeof content === 'string' ? /*#__PURE__*/React.createElement("img", {
    className: styling.media.poster({
      size: fullscreen ? 'fullscreen' : 'default'
    }),
    "aria-label": title,
    alt: title,
    ref: ref,
    src: content
  }) : /*#__PURE__*/React.isValidElement(content) ? /*#__PURE__*/React.cloneElement(content, {
    className: styling.media.poster({
      size: fullscreen ? 'fullscreen' : 'default'
    })
  }) : /*#__PURE__*/React.createElement(React.Fragment, null);
});

var mediaControllerSelector$5 = function mediaControllerSelector(_ref) {
  var duration = _ref.duration,
    progress = _ref.progress,
    requestSeek = _ref.requestSeek,
    buffered = _ref.buffered;
  return {
    duration: duration,
    progress: progress,
    requestSeek: requestSeek,
    buffered: buffered
  };
};
var Progress = function Progress(props) {
  var _useMediaController = useMediaController(mediaControllerSelector$5),
    duration = _useMediaController.duration,
    progress = _useMediaController.progress,
    requestSeek = _useMediaController.requestSeek,
    buffered = _useMediaController.buffered;
  var _React$useMemo = React.useMemo(function () {
      return [0, duration && !isNaN(duration) ? duration : 0, progress && !isNaN(progress) ? progress : 0];
    }, [duration, progress]),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 3),
    min = _React$useMemo2[0],
    max = _React$useMemo2[1],
    current = _React$useMemo2[2];
  var value = React.useMemo(function () {
    return current / (max - min);
  }, [min, max, current]);
  var secondaryValue = React.useMemo(function () {
    return buffered / (max - min);
  }, [min, max, buffered]);
  var onChange = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(value) {
      var _props$onSeek;
      var newSeek;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newSeek = value * (max - min);
              _context.next = 3;
              return props === null || props === void 0 ? void 0 : (_props$onSeek = props.onSeek) === null || _props$onSeek === void 0 ? void 0 : _props$onSeek.call(props, newSeek);
            case 3:
              requestSeek(newSeek);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [max, min, requestSeek, props]);
  var durationMinutes = React.useMemo(function () {
    return (duration / 60).toFixed(1);
  }, [duration]);
  return /*#__PURE__*/React.createElement(BaseSlider, {
    ariaName: "progress of ".concat(durationMinutes, " minutes"),
    value: value,
    secondaryValue: secondaryValue,
    onChange: onChange
  });
};

var mediaControllerSelector$4 = function mediaControllerSelector(_ref) {
  var duration = _ref.duration,
    progress = _ref.progress,
    live = _ref.live;
  return {
    duration: duration,
    progress: progress,
    live: live
  };
};
var getFormattedMinutesAndSeconds = function getFormattedMinutesAndSeconds(valueInSeconds) {
  if (valueInSeconds !== null && !isNaN(valueInSeconds) && isFinite(valueInSeconds)) {
    var roundedValue = Math.round(valueInSeconds);
    var minutes = Math.floor(roundedValue / 60);
    var seconds = Math.floor(roundedValue % 60);
    return "".concat(minutes, ":").concat(seconds < 10 ? '0' : '').concat(seconds);
  }
  return "0:00";
};
var TimeDisplay = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$4),
    duration = _useMediaController.duration,
    progress = _useMediaController.progress,
    live = _useMediaController.live;
  var formattedProgress = React.useMemo(function () {
    return getFormattedMinutesAndSeconds(progress !== null && progress !== void 0 ? progress : 0);
  }, [progress]);
  var formattedDuration = React.useMemo(function () {
    return getFormattedMinutesAndSeconds(duration !== null && duration !== void 0 ? duration : null);
  }, [duration]);
  var formattedTime = React.useMemo(function () {
    return live ? formattedProgress : "".concat(formattedProgress, " / ").concat(formattedDuration);
  }, [formattedProgress, formattedDuration, live]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", _extends({
    className: styling.time.text(),
    "aria-label": 'Playback time',
    ref: ref
  }, props), formattedTime), live && /*#__PURE__*/React.createElement("div", {
    className: styling.time.container()
  }, /*#__PURE__*/React.createElement("div", {
    className: styling.time.liveIndicator()
  }), /*#__PURE__*/React.createElement("span", _extends({
    className: styling.time.text(),
    "aria-label": 'Live streaming media',
    ref: ref
  }, props), "LIVE")));
});

var _excluded$1 = ["content"];
var Title = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var content = props.content,
    rest = _objectWithoutProperties(props, _excluded$1);
  return /*#__PURE__*/React.createElement("span", _extends({
    className: styling.title(),
    "aria-label": 'Title',
    ref: ref
  }, rest), content);
});

var _excluded = ["unmutedIcon", "mutedIcon", "onClick", "showSlider"];
var DefaultMutedIcon = function DefaultMutedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9.25,9 7.98,10.27 24.71,27 l 1.27,-1.27 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"
  }));
};
var DefaultUnmutedIcon = function DefaultUnmutedIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 36 36"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z"
  }));
};
var mediaControllerSelector$3 = function mediaControllerSelector(_ref) {
  var isVolumeChangeSupported = _ref.isVolumeChangeSupported,
    requestToggleMute = _ref.requestToggleMute,
    requestVolume = _ref.requestVolume,
    muted = _ref.muted;
  return {
    isVolumeChangeSupported: isVolumeChangeSupported,
    requestToggleMute: requestToggleMute,
    requestVolume: requestVolume,
    muted: muted
  };
};
var Volume = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useMediaController = useMediaController(mediaControllerSelector$3),
    requestToggleMute = _useMediaController.requestToggleMute,
    muted = _useMediaController.muted,
    requestVolume = _useMediaController.requestVolume,
    isVolumeChangeSupported = _useMediaController.isVolumeChangeSupported;
  var unmutedIcon = props.unmutedIcon,
    mutedIcon = props.mutedIcon,
    onClick = props.onClick,
    _props$showSlider = props.showSlider,
    showSlider = _props$showSlider === void 0 ? true : _props$showSlider,
    rest = _objectWithoutProperties(props, _excluded);
  var onClickComposed = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onClick === null || onClick === void 0 ? void 0 : onClick(e);
            case 2:
              if (!showSlider && isVolumeChangeSupported) {
                if (muted) {
                  requestVolume(1);
                } else {
                  requestVolume(0);
                }
              } else {
                requestToggleMute();
              }
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onClick, requestToggleMute, requestVolume, showSlider, isVolumeChangeSupported, muted]);
  var _children = useConditionalIcon(!muted, unmutedIcon, /*#__PURE__*/React.createElement(DefaultUnmutedIcon, null), mutedIcon, /*#__PURE__*/React.createElement(DefaultMutedIcon, null));
  var title = React.useMemo(function () {
    return muted ? 'Unmute (m)' : 'Mute (m)';
  }, [muted]);
  return /*#__PURE__*/React.createElement("div", {
    className: styling.volume.container()
  }, /*#__PURE__*/React.createElement("button", _extends({
    className: styling.iconButton(),
    title: title,
    "aria-label": title,
    ref: ref,
    onClick: onClickComposed
  }, rest), _children), isVolumeChangeSupported && showSlider && /*#__PURE__*/React.createElement(VolumeProgress, null));
});
Volume.displayName = 'Volume';
var mediaControllerSelectorProgress = function mediaControllerSelectorProgress(_ref3) {
  var volume = _ref3.volume,
    requestVolume = _ref3.requestVolume,
    muted = _ref3.muted;
  return {
    volume: volume,
    requestVolume: requestVolume,
    muted: muted
  };
};
var VolumeProgress = function VolumeProgress() {
  var _useMediaController2 = useMediaController(mediaControllerSelectorProgress),
    volume = _useMediaController2.volume,
    requestVolume = _useMediaController2.requestVolume,
    muted = _useMediaController2.muted;
  var onChange = React.useCallback( /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(value) {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              requestVolume(value);
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }(), [requestVolume]);
  return /*#__PURE__*/React.createElement(BaseSlider, {
    ariaName: "volume",
    value: muted ? 0 : volume,
    onChange: onChange
  });
};

var mediaControllerSelector$2 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var AudioPlayer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var src = _ref2.src,
    autoPlay = _ref2.autoPlay,
    title = _ref2.title,
    loop = _ref2.loop,
    muted = _ref2.muted,
    objectFit = _ref2.objectFit;
  var _useMediaController = useMediaController(mediaControllerSelector$2),
    fullscreen = _useMediaController.fullscreen;
  var filteredSources = React.useMemo(function () {
    return src.filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.mime) && canPlayMediaNatively(s.mime);
    });
  }, [src]);
  return /*#__PURE__*/React.createElement("audio", {
    className: styling.media.audio({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Audio player',
    role: "audio",
    autoPlay: autoPlay,
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    muted: muted
  }, filteredSources.map(function (source) {
    return /*#__PURE__*/React.createElement("source", {
      key: source.src,
      src: source.src,
      type: source.mime
    });
  }), "Your browser doesn't support the HTML5 <code>audio</code> tag, or the audio format.");
});
AudioPlayer.displayName = 'AudioPlayer';

var mediaControllerSelector$1 = function mediaControllerSelector(_ref) {
  var fullscreen = _ref.fullscreen;
  return {
    fullscreen: fullscreen
  };
};
var VideoPlayer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var src = _ref2.src,
    autoPlay = _ref2.autoPlay,
    title = _ref2.title,
    loop = _ref2.loop,
    muted = _ref2.muted,
    poster = _ref2.poster,
    objectFit = _ref2.objectFit;
  var _useMediaController = useMediaController(mediaControllerSelector$1),
    fullscreen = _useMediaController.fullscreen;
  var filteredSources = React.useMemo(function () {
    return src === null || src === void 0 ? void 0 : src.filter(function (s) {
      return (s === null || s === void 0 ? void 0 : s.mime) && canPlayMediaNatively(s.mime);
    });
  }, [src]);
  return /*#__PURE__*/React.createElement("video", {
    className: styling.media.video({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Video player',
    role: "video",
    autoPlay: autoPlay,
    width: "100%",
    height: "100%",
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    muted: muted,
    poster: poster
  }, filteredSources === null || filteredSources === void 0 ? void 0 : filteredSources.map(function (source) {
    return /*#__PURE__*/React.createElement("source", {
      key: source.src,
      src: source.src,
      type: source.mime
    });
  }), "Your browser doesn't support the HTML5 <code>video</code> tag, or the video format.");
});
VideoPlayer.displayName = 'VideoPlayer';

var mediaControllerSelector = function mediaControllerSelector(_ref) {
  var _element = _ref._element,
    fullscreen = _ref.fullscreen,
    setLive = _ref.setLive,
    onDurationChange = _ref.onDurationChange,
    onCanPlay = _ref.onCanPlay;
  return {
    element: _element,
    fullscreen: fullscreen,
    setLive: setLive,
    onDurationChange: onDurationChange,
    onCanPlay: onCanPlay
  };
};
var HlsPlayer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var hlsConfig = props.hlsConfig,
    src = props.src,
    autoPlay = props.autoPlay,
    title = props.title,
    loop = props.loop,
    muted = props.muted,
    poster = props.poster,
    objectFit = props.objectFit;
  var _useMediaController = useMediaController(mediaControllerSelector),
    element = _useMediaController.element,
    fullscreen = _useMediaController.fullscreen,
    setLive = _useMediaController.setLive,
    onDurationChange = _useMediaController.onDurationChange,
    onCanPlay = _useMediaController.onCanPlay;
  var _React$useMemo = React.useMemo(function () {
      return [isHlsSupported(), canPlayMediaNatively('application/vnd.apple.mpegurl')];
    }, []),
    _React$useMemo2 = _slicedToArray(_React$useMemo, 2),
    canUseHlsjs = _React$useMemo2[0],
    canPlayAppleMpeg = _React$useMemo2[1];
  React.useEffect(function () {
    if (element && canUseHlsjs && !canPlayAppleMpeg && src.src) {
      var onError = function onError(error) {
        var _error$response;
        console.warn((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data.toString());
      };
      var _createNewHls = createNewHls(src.src, element, {
          onLive: setLive,
          onDuration: onDurationChange,
          onCanPlay: onCanPlay,
          onError: onError
        }, _objectSpread2({
          autoplay: autoPlay
        }, hlsConfig)),
        destroy = _createNewHls.destroy;
      return function () {
        destroy();
      };
    }
  }, [autoPlay, hlsConfig, src, element, canUseHlsjs, canPlayAppleMpeg, setLive, onDurationChange, onCanPlay]);

  // if Media Source is supported and if HLS is not supported by default in the user's browser, use HLS.js
  // fallback to using a regular video player
  return !canPlayAppleMpeg && canUseHlsjs ? /*#__PURE__*/React.createElement("video", {
    className: styling.media.video({
      size: fullscreen ? 'fullscreen' : objectFit
    }),
    loop: loop,
    "aria-label": title !== null && title !== void 0 ? title : 'Video player',
    role: "video",
    width: "100%",
    height: "100%",
    ref: ref,
    "webkit-playsinline": "true",
    playsInline: true,
    autoPlay: autoPlay,
    muted: muted,
    poster: poster
  }) : /*#__PURE__*/React.createElement(VideoPlayer, _extends({}, props, {
    ref: ref,
    src: [_objectSpread2(_objectSpread2({}, src), {}, {
      type: 'video'
    })]
  }));
});
HlsPlayer.displayName = 'HlsPlayer';

/**
 * Retrieves the playback info for a playback ID or source URL.
 * Conditionally, automatically imports a source URL from IPFS or Arweave.
 *
 * @param src Source URL for the media.
 * @param playbackId Playback ID of the media.
 */
var usePlaybackInfoOrImport = function usePlaybackInfoOrImport(_ref) {
  var _importedAsset$, _ref2, _decentralizedSrcOrPl;
  var decentralizedSrcOrPlaybackId = _ref.decentralizedSrcOrPlaybackId,
    playbackId = _ref.playbackId,
    refetchPlaybackInfoInterval = _ref.refetchPlaybackInfoInterval,
    autoUrlUpload = _ref.autoUrlUpload,
    onAssetStatusChange = _ref.onAssetStatusChange;
  var _useCreateAsset = useCreateAsset(decentralizedSrcOrPlaybackId ? {
      sources: [{
        name: decentralizedSrcOrPlaybackId.id,
        url: decentralizedSrcOrPlaybackId.url
      }]
    } : null),
    importAsset = _useCreateAsset.mutate,
    importedAsset = _useCreateAsset.data,
    status = _useCreateAsset.status;
  var _useAsset = useAsset({
      assetId: importedAsset === null || importedAsset === void 0 ? void 0 : (_importedAsset$ = importedAsset[0]) === null || _importedAsset$ === void 0 ? void 0 : _importedAsset$.id,
      refetchInterval: function refetchInterval(asset) {
        var _asset$status;
        return (asset === null || asset === void 0 ? void 0 : (_asset$status = asset.status) === null || _asset$status === void 0 ? void 0 : _asset$status.phase) !== 'ready' ? refetchPlaybackInfoInterval : false;
      }
    }),
    asset = _useAsset.data;
  React.useEffect(function () {
    if (asset !== null && asset !== void 0 && asset.status) {
      onAssetStatusChange(asset.status);
    }
  }, [asset === null || asset === void 0 ? void 0 : asset.status, onAssetStatusChange]);
  var _usePlaybackInfo = usePlaybackInfo({
      // attempt to fetch if the source is from decentralized storage, or a playback ID is provided
      playbackId: (_ref2 = (_decentralizedSrcOrPl = decentralizedSrcOrPlaybackId === null || decentralizedSrcOrPlaybackId === void 0 ? void 0 : decentralizedSrcOrPlaybackId.id) !== null && _decentralizedSrcOrPl !== void 0 ? _decentralizedSrcOrPl : playbackId) !== null && _ref2 !== void 0 ? _ref2 : undefined,
      refetchInterval: function refetchInterval(info) {
        return info ? false : refetchPlaybackInfoInterval;
      }
    }),
    playbackInfo = _usePlaybackInfo.data,
    playbackInfoError = _usePlaybackInfo.error;

  // trigger an import if the playback info had a 404 error and the asset is an IPFS source
  // also must be enabled
  React.useEffect(function () {
    if (autoUrlUpload && importAsset && status === 'idle' && (playbackInfoError === null || playbackInfoError === void 0 ? void 0 : playbackInfoError.code) === 404) {
      importAsset();
    }
  }, [autoUrlUpload, playbackInfoError, importAsset, status]);
  return playbackInfo;
};

var defaultIpfsGateway = 'https://w3s.link';
var defaultArweaveGateway = 'https://arweave.net';
function Player(_ref) {
  var _sourceMimeTyped$3;
  var autoPlay = _ref.autoPlay,
    children = _ref.children,
    controls = _ref.controls,
    muted = _ref.muted,
    playbackId = _ref.playbackId,
    _ref$refetchPlaybackI = _ref.refetchPlaybackInfoInterval,
    refetchPlaybackInfoInterval = _ref$refetchPlaybackI === void 0 ? 5000 : _ref$refetchPlaybackI,
    src = _ref.src,
    theme = _ref.theme,
    title = _ref.title,
    poster = _ref.poster,
    loop = _ref.loop,
    _ref$showLoadingSpinn = _ref.showLoadingSpinner,
    showLoadingSpinner = _ref$showLoadingSpinn === void 0 ? true : _ref$showLoadingSpinn,
    _ref$showTitle = _ref.showTitle,
    showTitle = _ref$showTitle === void 0 ? true : _ref$showTitle,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? '16to9' : _ref$aspectRatio,
    _ref$objectFit = _ref.objectFit,
    objectFit = _ref$objectFit === void 0 ? 'cover' : _ref$objectFit,
    showPipButton = _ref.showPipButton,
    _ref$autoUrlUpload = _ref.autoUrlUpload,
    autoUrlUpload = _ref$autoUrlUpload === void 0 ? {
      fallback: true
    } : _ref$autoUrlUpload,
    onMetricsError = _ref.onMetricsError,
    jwt = _ref.jwt;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mediaElement = _React$useState2[0],
    setMediaElement = _React$useState2[1];
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    uploadStatus = _React$useState4[0],
    setUploadStatus = _React$useState4[1];
  var onAssetStatusChange = React.useCallback(function (status) {
    setUploadStatus(status);
  }, [setUploadStatus]);

  // check if the src or playbackId are decentralized storage sources (does not handle src arrays)
  var decentralizedSrcOrPlaybackId = React.useMemo(function () {
    var _parseCid, _parseCid2;
    return playbackId ? (_parseCid = parseCid(playbackId)) !== null && _parseCid !== void 0 ? _parseCid : parseArweaveTxId(playbackId) : !Array.isArray(src) ? (_parseCid2 = parseCid(src)) !== null && _parseCid2 !== void 0 ? _parseCid2 : parseArweaveTxId(src) : null;
  }, [playbackId, src]);
  var playbackInfo = usePlaybackInfoOrImport({
    decentralizedSrcOrPlaybackId: decentralizedSrcOrPlaybackId,
    playbackId: playbackId,
    refetchPlaybackInfoInterval: refetchPlaybackInfoInterval,
    autoUrlUpload: autoUrlUpload,
    onAssetStatusChange: onAssetStatusChange
  });
  var _React$useState5 = React.useState([]),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    playbackUrls = _React$useState6[0],
    setPlaybackUrls = _React$useState6[1];
  React.useEffect(function () {
    var _playbackInfo$meta, _playbackInfo$meta$so, _playbackInfo$meta$so2;
    var playbackInfoSources = playbackInfo === null || playbackInfo === void 0 ? void 0 : (_playbackInfo$meta = playbackInfo.meta) === null || _playbackInfo$meta === void 0 ? void 0 : (_playbackInfo$meta$so = _playbackInfo$meta.source) === null || _playbackInfo$meta$so === void 0 ? void 0 : (_playbackInfo$meta$so2 = _playbackInfo$meta$so.map(function (s) {
      return s === null || s === void 0 ? void 0 : s.url;
    })) === null || _playbackInfo$meta$so2 === void 0 ? void 0 : _playbackInfo$meta$so2.filter(function (s) {
      return s;
    });
    if (playbackInfoSources) {
      setPlaybackUrls(playbackInfoSources);
    }
  }, [playbackInfo]);
  var sourceMimeTyped = React.useMemo(function () {
    var _mediaSourceTypes$, _mediaSourceTypes$2, _mediaSourceTypes$3;
    // cast all URLs to an array of strings
    var sources = playbackUrls.length > 0 ? playbackUrls : typeof src === 'string' ? [src] : src;
    if (!sources) {
      return null;
    }
    var authenticatedSources = sources.map(function (source) {
      // append the JWT to the query params
      if (jwt) {
        var url = new URL(source);
        url.searchParams.append('jwt', jwt);
        return url.toString();
      }
      return source;
    });
    var mediaSourceTypes = authenticatedSources.map(function (s) {
      return typeof s === 'string' ? getMediaSourceType(s) : s;
    }).filter(function (s) {
      return s;
    });

    // if there are multiple Hls sources, we take only the first one
    // otherwise we pass all sources to the video or audio player components
    if (mediaSourceTypes.every(function (s) {
      return s.type === 'hls';
    }) && (mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : (_mediaSourceTypes$ = mediaSourceTypes[0]) === null || _mediaSourceTypes$ === void 0 ? void 0 : _mediaSourceTypes$.type) === 'hls') {
      return mediaSourceTypes[0];
    }

    // if the player is auto uploading, we do not play back the detected input file unless specified
    // e.g. https://arweave.net/84KylA52FVGLxyvLADn1Pm8Q3kt8JJM74B87MeoBt2w/400019.mp4
    if (decentralizedSrcOrPlaybackId) {
      if (!autoUrlUpload) {
        return null;
      } else {
        if (typeof autoUrlUpload !== 'boolean') {
          if (decentralizedSrcOrPlaybackId.url.startsWith('ar://')) {
            var _autoUrlUpload$arweav;
            var _URL = new URL((_autoUrlUpload$arweav = autoUrlUpload.arweaveGateway) !== null && _autoUrlUpload$arweav !== void 0 ? _autoUrlUpload$arweav : defaultArweaveGateway),
              host = _URL.host;
            var _src = [{
              type: 'video',
              mime: 'video/mp4',
              src: "https://".concat(host, "/").concat(decentralizedSrcOrPlaybackId.id)
            }];
            return _src;
          } else if (decentralizedSrcOrPlaybackId.url.startsWith('ipfs://')) {
            var _autoUrlUpload$ipfsGa;
            var _URL2 = new URL((_autoUrlUpload$ipfsGa = autoUrlUpload.ipfsGateway) !== null && _autoUrlUpload$ipfsGa !== void 0 ? _autoUrlUpload$ipfsGa : defaultIpfsGateway),
              _host = _URL2.host;
            var _src2 = [{
              type: 'video',
              mime: 'video/mp4',
              src: "https://".concat(_host, "/ipfs/").concat(decentralizedSrcOrPlaybackId.id)
            }];
            return _src2;
          }
        }
      }
    }

    // we filter by the first source type in the array provided
    var mediaSourceFiltered = (mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : (_mediaSourceTypes$2 = mediaSourceTypes[0]) === null || _mediaSourceTypes$2 === void 0 ? void 0 : _mediaSourceTypes$2.type) === 'audio' ? mediaSourceTypes.filter(function (s) {
      return s.type === 'audio';
    }) : (mediaSourceTypes === null || mediaSourceTypes === void 0 ? void 0 : (_mediaSourceTypes$3 = mediaSourceTypes[0]) === null || _mediaSourceTypes$3 === void 0 ? void 0 : _mediaSourceTypes$3.type) === 'video' ? mediaSourceTypes.filter(function (s) {
      return s.type === 'video';
    }) : null;
    return mediaSourceFiltered;
  }, [decentralizedSrcOrPlaybackId, playbackUrls, src, autoUrlUpload, jwt]);
  var hidePosterOnPlayed = React.useMemo(function () {
    var _sourceMimeTyped$;
    return Array.isArray(sourceMimeTyped) ? (sourceMimeTyped === null || sourceMimeTyped === void 0 ? void 0 : (_sourceMimeTyped$ = sourceMimeTyped[0]) === null || _sourceMimeTyped$ === void 0 ? void 0 : _sourceMimeTyped$.type) !== 'audio' ? true : undefined : undefined;
  }, [sourceMimeTyped]);
  var playerRef = React.useCallback(function (element) {
    if (element) {
      setMediaElement(element);
    }
  }, []);
  React.useEffect(function () {
    var _sourceMimeTyped$2;
    var _addMediaMetrics = addMediaMetrics(mediaElement, Array.isArray(sourceMimeTyped) ? sourceMimeTyped === null || sourceMimeTyped === void 0 ? void 0 : (_sourceMimeTyped$2 = sourceMimeTyped[0]) === null || _sourceMimeTyped$2 === void 0 ? void 0 : _sourceMimeTyped$2.src : sourceMimeTyped === null || sourceMimeTyped === void 0 ? void 0 : sourceMimeTyped.src, function (e) {
        onMetricsError === null || onMetricsError === void 0 ? void 0 : onMetricsError(e);
        console.error('Not able to report player metrics', e);
      }),
      destroy = _addMediaMetrics.destroy;
    return destroy;
  }, [onMetricsError, mediaElement, sourceMimeTyped]);
  var contextTheme = useTheme(theme);
  var topLoadingText = React.useMemo(function () {
    return (uploadStatus === null || uploadStatus === void 0 ? void 0 : uploadStatus.phase) === 'processing' && isNumber(uploadStatus === null || uploadStatus === void 0 ? void 0 : uploadStatus.progress) ? "Processing: ".concat((Number(uploadStatus === null || uploadStatus === void 0 ? void 0 : uploadStatus.progress) * 100).toFixed(0), "%") : (uploadStatus === null || uploadStatus === void 0 ? void 0 : uploadStatus.phase) === 'failed' ? 'Upload Failed' : null;
  }, [uploadStatus]);
  return /*#__PURE__*/React.createElement(MediaControllerProvider, {
    element: mediaElement,
    options: controls
  }, /*#__PURE__*/React.createElement(Container, {
    className: contextTheme,
    aspectRatio: aspectRatio
  }, sourceMimeTyped && !Array.isArray(sourceMimeTyped) ? /*#__PURE__*/React.createElement(HlsPlayer, {
    ref: playerRef,
    autoPlay: autoPlay,
    muted: autoPlay ? true : muted,
    src: sourceMimeTyped,
    poster: typeof poster === 'string' ? poster : undefined,
    loop: loop,
    objectFit: objectFit
  }) : (sourceMimeTyped === null || sourceMimeTyped === void 0 ? void 0 : (_sourceMimeTyped$3 = sourceMimeTyped[0]) === null || _sourceMimeTyped$3 === void 0 ? void 0 : _sourceMimeTyped$3.type) === 'audio' ? /*#__PURE__*/React.createElement(AudioPlayer, {
    ref: playerRef,
    autoPlay: autoPlay,
    muted: autoPlay ? true : muted,
    src: sourceMimeTyped,
    loop: loop,
    objectFit: objectFit
  }) : /*#__PURE__*/React.createElement(VideoPlayer, {
    ref: playerRef,
    autoPlay: autoPlay,
    muted: autoPlay ? true : muted,
    src: sourceMimeTyped,
    poster: typeof poster === 'string' ? poster : undefined,
    loop: loop,
    objectFit: objectFit
  }), /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ControlsContainer, {
    hidePosterOnPlayed: hidePosterOnPlayed,
    showLoadingSpinner: showLoadingSpinner,
    topLoadingText: topLoadingText,
    poster: poster && /*#__PURE__*/React.createElement(Poster, {
      content: poster,
      title: title
    }),
    top: /*#__PURE__*/React.createElement(React.Fragment, null, title && showTitle && /*#__PURE__*/React.createElement(Title, {
      content: title
    })),
    middle: /*#__PURE__*/React.createElement(Progress, null),
    left: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlayButton, null), /*#__PURE__*/React.createElement(Volume, null), /*#__PURE__*/React.createElement(TimeDisplay, null)),
    right: /*#__PURE__*/React.createElement(React.Fragment, null, showPipButton && /*#__PURE__*/React.createElement(PictureInPictureButton, null), /*#__PURE__*/React.createElement(FullscreenButton, null))
  }))));
}

function prefetchPlayer(_x, _x2) {
  return _prefetchPlayer.apply(this, arguments);
}
function _prefetchPlayer() {
  _prefetchPlayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(props, config) {
    var _props$playbackId;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", prefetchPlaybackInfo({
              playbackId: (_props$playbackId = props === null || props === void 0 ? void 0 : props.playbackId) !== null && _props$playbackId !== void 0 ? _props$playbackId : undefined,
              clearClient: props.clearClient
            }, config));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _prefetchPlayer.apply(this, arguments);
}

export { ControlsContainer as C, FullscreenButton as F, MediaControllerProvider as M, PictureInPictureButton as P, TimeDisplay as T, Volume as V, PlayButton as a, Player as b, Poster as c, Progress as d, Title as e, useTheme as f, prefetchPlayer as p, useMediaController as u };
